import React, { useState } from 'react';
import { FileText, X, ExternalLink, ChevronLeft, ChevronRight } from 'lucide-react';

const tortenKataloge = [
  {
    id: 1,
    title: "Tortenbestellung",
    description: "Unser komplettes Sortiment an Torten zum Bestellen",
    pdfUrl: "https://customer-assets.emergentagent.com/job_e805455d-3644-471b-ab46-8d21c79b0289/artifacts/l555q1xh_Tortenbestellung.pdf",
    icon: "🎂"
  },
  {
    id: 2,
    title: "Hochzeitstorten",
    description: "Elegante Torten für den schönsten Tag",
    pdfUrl: "https://customer-assets.emergentagent.com/job_e805455d-3644-471b-ab46-8d21c79b0289/artifacts/sk6jlgm6_Hochzeitstorten.pdf",
    icon: "💒"
  },
  {
    id: 3,
    title: "Geburtstagstorten",
    description: "Glückwunschtorten für jeden Anlass",
    pdfUrl: "https://customer-assets.emergentagent.com/job_e805455d-3644-471b-ab46-8d21c79b0289/artifacts/a02eko1t_Geburtstags-und%20Gluckwunschtorten.pdf",
    icon: "🎁"
  },
  {
    id: 4,
    title: "Kindergeburtstag",
    description: "Bunte Torten für kleine Geburtstagskinder",
    pdfUrl: "https://customer-assets.emergentagent.com/job_e805455d-3644-471b-ab46-8d21c79b0289/artifacts/2vu1xlq5_Kindergeburtstags-torten.pdf",
    icon: "🧒"
  },
  {
    id: 5,
    title: "Muttertagstorten",
    description: "Besondere Torten zum Muttertag",
    pdfUrl: "https://customer-assets.emergentagent.com/job_e805455d-3644-471b-ab46-8d21c79b0289/artifacts/rjfdamuj_Muttertagstorten.pdf",
    icon: "💐"
  },
  {
    id: 6,
    title: "Saisontorten",
    description: "Saisonale Spezialitäten das ganze Jahr",
    pdfUrl: "https://customer-assets.emergentagent.com/job_e805455d-3644-471b-ab46-8d21c79b0289/artifacts/t0jceql4_Saisontorten.pdf",
    icon: "🍂"
  },
  {
    id: 7,
    title: "Spezialtorten",
    description: "Individuelle Kreationen für besondere Anlässe",
    pdfUrl: "https://customer-assets.emergentagent.com/job_e805455d-3644-471b-ab46-8d21c79b0289/artifacts/io0i9nfn_Speziatorten.pdf",
    icon: "⭐"
  },
  {
    id: 8,
    title: "Taufe, Kommunion & Firmung",
    description: "Festliche Torten für religiöse Feiern",
    pdfUrl: "https://customer-assets.emergentagent.com/job_e805455d-3644-471b-ab46-8d21c79b0289/artifacts/qbqplzs3_Taufe%20Kommunion%20Firmung.pdf",
    icon: "✝️"
  }
];

export const TortenSection = () => {
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openPdfViewer = (katalog, index) => {
    // On mobile (< 768px), open PDF directly in new tab
    if (window.innerWidth < 768) {
      window.open(katalog.pdfUrl, '_blank');
      return;
    }
    // On desktop, show modal
    setSelectedPdf(katalog);
    setCurrentIndex(index);
  };

  const closePdfViewer = () => {
    setSelectedPdf(null);
  };

  const goToPrevious = () => {
    const newIndex = currentIndex === 0 ? tortenKataloge.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    setSelectedPdf(tortenKataloge[newIndex]);
  };

  const goToNext = () => {
    const newIndex = currentIndex === tortenKataloge.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    setSelectedPdf(tortenKataloge[newIndex]);
  };

  return (
    <section id="torten" className="py-16 sm:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block text-[#61525a] font-medium text-xs sm:text-sm tracking-wider uppercase mb-3 sm:mb-4">
            Unsere Tortenkataloge
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e1919] mb-4 sm:mb-6">
            Traumhafte Torten
          </h2>
          <p className="text-[#736c64] text-base sm:text-lg max-w-2xl mx-auto px-2">
            Entdecken Sie unsere handgefertigten Torten für jeden Anlass – 
            von klassisch bis kreativ, immer mit Liebe gebacken.
          </p>
        </div>

        {/* Katalog Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
          {tortenKataloge.map((katalog, index) => (
            <button
              key={katalog.id}
              onClick={() => openPdfViewer(katalog, index)}
              className="group relative bg-[#f7f5f2] rounded-xl sm:rounded-2xl p-4 sm:p-6 transition-all duration-300 hover:bg-[#61525a] hover:-translate-y-2 hover:shadow-xl text-left"
            >
              {/* Icon */}
              <div className="text-3xl sm:text-4xl mb-3 sm:mb-4 transition-transform duration-300 group-hover:scale-110">
                {katalog.icon}
              </div>
              
              {/* Title */}
              <h3 className="font-bold text-[#1e1919] text-sm sm:text-base mb-1 sm:mb-2 transition-colors duration-300 group-hover:text-white line-clamp-2">
                {katalog.title}
              </h3>
              
              {/* Description - Hidden on mobile */}
              <p className="hidden sm:block text-[#736c64] text-xs sm:text-sm transition-colors duration-300 group-hover:text-white/70 line-clamp-2">
                {katalog.description}
              </p>

              {/* View indicator */}
              <div className="flex items-center gap-1 mt-3 sm:mt-4 text-[#61525a] text-xs sm:text-sm font-medium transition-colors duration-300 group-hover:text-[#fad24b]">
                <FileText className="w-3 sm:w-4 h-3 sm:h-4" />
                <span>Ansehen</span>
              </div>

              {/* Hover Line */}
              <div className="absolute bottom-0 left-0 w-0 h-1 bg-[#fad24b] rounded-b-xl sm:rounded-b-2xl transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </div>

        {/* Call to action */}
        <div className="mt-10 sm:mt-12 text-center">
          <p className="text-[#736c64] text-sm sm:text-base mb-3">
            Individuelle Wünsche? Wir beraten Sie gerne!
          </p>
          <a
            href="tel:01 9825285"
            className="inline-flex items-center gap-2 text-[#61525a] font-medium hover:text-[#4a3f45] transition-colors duration-300"
          >
            Jetzt anrufen: 01 9825285
            <span>→</span>
          </a>
        </div>
      </div>

      {/* PDF Viewer Modal */}
      {selectedPdf && (
        <div 
          className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4"
          onClick={closePdfViewer}
        >
          <div 
            className="relative bg-white rounded-xl sm:rounded-2xl w-full max-w-5xl h-[90vh] sm:h-[85vh] flex flex-col overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="flex items-center justify-between p-3 sm:p-4 border-b border-[#e5e2df] bg-[#f7f5f2]">
              <div className="flex items-center gap-2 sm:gap-3">
                <span className="text-xl sm:text-2xl">{selectedPdf.icon}</span>
                <div>
                  <h3 className="font-bold text-[#1e1919] text-sm sm:text-lg">{selectedPdf.title}</h3>
                  <p className="text-[#736c64] text-xs sm:text-sm hidden sm:block">{selectedPdf.description}</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {/* Navigation Buttons */}
                <button
                  onClick={goToPrevious}
                  className="p-2 rounded-lg bg-white hover:bg-[#61525a] hover:text-white transition-colors duration-200"
                  title="Vorheriger Katalog"
                >
                  <ChevronLeft className="w-5 h-5" />
                </button>
                <button
                  onClick={goToNext}
                  className="p-2 rounded-lg bg-white hover:bg-[#61525a] hover:text-white transition-colors duration-200"
                  title="Nächster Katalog"
                >
                  <ChevronRight className="w-5 h-5" />
                </button>
                {/* Open in new tab */}
                <a
                  href={selectedPdf.pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-lg bg-white hover:bg-[#61525a] hover:text-white transition-colors duration-200"
                  title="In neuem Tab öffnen"
                >
                  <ExternalLink className="w-5 h-5" />
                </a>
                {/* Close button */}
                <button
                  onClick={closePdfViewer}
                  className="p-2 rounded-lg bg-white hover:bg-red-500 hover:text-white transition-colors duration-200"
                  title="Schließen"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>

            {/* PDF Embed */}
            <div className="flex-1 bg-[#525252]">
              <iframe
                src={`${selectedPdf.pdfUrl}#toolbar=1&navpanes=0&scrollbar=1`}
                className="w-full h-full"
                title={selectedPdf.title}
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default TortenSection;
